import { topBarHeight } from "assets/jss/material-dashboard-react";
import { backgroundColor } from "assets/jss/material-dashboard-react";
import {
  drawerWidth,
  transition,
  container
} from "assets/jss/material-dashboard-react.js";

const appStyle = theme => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh",
    background: backgroundColor,
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    width: "100%",
    overflowScrolling: "touch",
    background: backgroundColor,
  },
  mainPanel2: {
    // [theme.breakpoints.up("md")]: {
    //   width: `calc(100% - ${drawerWidth}px)`
    // },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    width: "100%",
    overflowScrolling: "touch",
    background: backgroundColor,
  },
  marginBarTop: {
    marginTop: `${topBarHeight}px`,
  },
  // Layout content
  content: {
    marginTop: `${topBarHeight + 30}px`,
    padding: "30px 15px",
    minHeight: "calc(100vh - 123px)", 
  },
  container,
  map: {
    marginTop: "70px"
  }
});

export default appStyle;
